import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-promos',
  templateUrl: './active-promos.component.html',
  styleUrls: ['./active-promos.component.css']
})
export class ActivePromosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
